import { z } from "zod";
import { AnfrageStatusSchema, DateiRefSchema } from "./common.js";

/**
 * Phase 0 — Datei-Manifest direkt nach Upload (oder IMAP-Pull, H8).
 * Kein Parsing der Inhalte — nur Metadaten und Stammdaten der Anfrage.
 */
export const AnfrageRohdatenSchema = z.object({
  schemaVersion: z.literal(1).default(1),
  anfrageId: z.string(),
  tenantId: z.string(),
  eingangsDatum: z.string().datetime(),
  status: AnfrageStatusSchema.default("eingegangen"),
  kunde: z.object({
    /** Optionale Referenz auf einen Eintrag in kunden.json (Sprint G2).
     *  Wenn gesetzt, ueberlagern name + kundenNr aus der Stammdaten-Pflege
     *  die Werte hier. Wenn nicht gesetzt = Legacy-Anfrage ohne Kunde-Pick. */
    id: z.string().optional(),
    name: z.string(),
    kundenNr: z.string().optional(),
  }),
  bauvorhaben: z.object({
    bezeichnung: z.string(),
    standort: z.string().optional(),
  }),
  abgabeDatum: z.string().datetime().nullable().default(null),
  freitext: z.string().default(""),
  dateien: z.array(DateiRefSchema).default([]),
  herkunft: z.enum(["upload", "imap", "api"]).default("upload"),
});

export type AnfrageRohdaten = z.infer<typeof AnfrageRohdatenSchema>;
